import type { Reply } from '@rp/contracts'

export const PUBLISHING_POLL_MS = 5_000

export const itemRefetchInterval = (item: { replies: readonly Reply[] } | undefined): number | false =>
  item?.replies.some((reply) => reply.status === 'publishing') === true ? PUBLISHING_POLL_MS : false
